/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateManualSubtasksRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {CreateManualSubtasksResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const createManualSubtasks = (request:CreateManualSubtasksRequest, options?: CashRequestOptions) => post<CreateManualSubtasksRequest, CreateManualSubtasksResponse>("/2.0/cash/create-manual-subtasks", request, {...options, rejectOnError: true })